"use client";

import { useEffect } from "react";

interface PreventRefreshDialogProps {
  enabled?: boolean;
}

/**
 * 브라우저의 자동 새로고침 확인 메시지를 방지하는 컴포넌트
 *
 * 화면 잠금 상태나 특정 상황에서 브라우저의 기본 새로고침 확인을 비활성화합니다.
 *
 * @param enabled - 기능 활성화 여부 (기본값: true)
 */
export function PreventRefreshDialog({
  enabled = true,
}: PreventRefreshDialogProps) {
  useEffect(() => {
    if (!enabled) return;

    // 새로고침 방지 핸들러
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      // 화면 잠금 상태나 페이지 숨김 상태에서 돌아온 경우 새로고침 방지
      if (document.hidden) {
        console.log("페이지 숨김 상태에서 새로고침 방지");
        event.preventDefault();
        event.returnValue = "";
        return "";
      }

      // 일반적인 경우에는 기본 동작 허용
      return undefined;
    };

    // 페이지 가시성 변경 감지
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("페이지가 숨겨짐 - 새로고침 방지 준비");
        // 페이지가 숨겨질 때 더 강력한 방지 설정
        window.onbeforeunload = () => {
          console.log("강력한 새로고침 방지 활성화");
          return "";
        };
      } else {
        console.log("페이지가 다시 보임");
        // 페이지가 다시 보일 때 일반 방지로 복원
        window.onbeforeunload = null;
      }
    };

    // 이벤트 리스너 등록
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("beforeunload", handleBeforeUnload, {
      capture: true,
    });

    // 초기 상태 확인
    handleVisibilityChange();

    // 컴포넌트 언마운트 시 정리
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("beforeunload", handleBeforeUnload, {
        capture: true,
      });
      window.onbeforeunload = null;
    };
  }, [enabled]);

  // 이 컴포넌트는 UI를 렌더링하지 않음
  return null;
}
